import { createContext } from "react";

const AuthorisationContext = createContext({
  userAuthorised: false,
  setAuthorisationStatus: () => {},
});

export default AuthorisationContext;
